import React, { useState } from 'react'
import { Message, Login, Done } from '@mui/icons-material'
import { Input, Modal, notification } from 'antd'
import './musicianContactForm.css'
import { useAuth0 } from '@auth0/auth0-react'
import { useParams } from 'react-router-dom'
import userClient from '../../../Api/Lirari/Clients/userClient'

const { TextArea } = Input

const MusicianContactForm = ({ editMode }: { editMode: boolean }) => {
  const { isAuthenticated, user, loginWithRedirect, getAccessTokenSilently } = useAuth0()
  const { uid: userId } = useParams()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [messageBody, setMessageBody] = useState('')
  const [isSending, setIsSending] = useState(false)

  // Modal to prompt user to sign in
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false)

  const showModal = () => {
    if (!isAuthenticated) {
      setIsLoginModalOpen(true)
    } else {
      setIsModalOpen(true)
    }
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handleLoginRedirect = () => {
    setIsLoginModalOpen(false)
    loginWithRedirect()
  }

  const handleSendMessage = async () => {
    if (!userId || !user?.email || !messageBody.trim()) {
      return
    }

    try {
      setIsSending(true)
      const token = await getAccessTokenSilently({
        authorizationParams: {
          scope: 'user:all',
        },
      })

      const success = await userClient.sendMessageToMusician(userId, messageBody, user.email, token)

      if (success) {
        notification.success({
          message: 'Message Sent',
          description: 'Your message has been sent successfully.',
        })
        setMessageBody('')
        setIsModalOpen(false)
      } else {
        notification.error({
          message: 'Failed to Send',
          description: 'There was a problem sending your message. Please try again.',
        })
      }
    } catch (error) {
      console.error('Error sending message:', error)
      notification.error({
        message: 'Error',
        description: 'An unexpected error occurred. Please try again later.',
      })
    } finally {
      setIsSending(false)
    }
  }

  return (
    <>
      {/* Message form modal */}
      <Modal centered open={isModalOpen} closable={true} onCancel={handleCloseModal} footer={null}>
        <div className="flex flex-col items-center w-full">
          <TextArea
            autoSize={{ minRows: 4, maxRows: 10 }}
            variant="borderless"
            className="text-area"
            placeholder="Your message to the musician"
            value={messageBody}
            onChange={(e) => setMessageBody(e.target.value)}
          />

          <p className="text-xs text-white w-full text-center mb-2">
            Musician will receive your message and contact details ({user?.email})
          </p>

          <button
            className="flex p-0 mt-2.5 justify-center items-center size-12 rounded-full bg-white hover:bg-[#cdcdcd]/90 [&>svg]:text-black"
            onClick={handleSendMessage}
            disabled={isSending}
          >
            {isSending ? (
              <span className="flex items-center justify-center h-6 w-6 border-2 border-t-transparent border-[#8830C7] rounded-full animate-spin"></span>
            ) : (
              <Done />
            )}
          </button>
        </div>
      </Modal>

      {/* Login prompt modal */}
      <Modal centered open={isLoginModalOpen} closable={true} onCancel={() => setIsLoginModalOpen(false)} footer={null}>
        <div className="flex flex-col items-center w-full">
          <p className="text-sm text-white mb-4 text-center">Please sign in to contact this musician</p>

          <button
            className="flex p-0 justify-center items-center size-12 rounded-full bg-white hover:bg-[#cdcdcd]/90 [&>svg]:text-black"
            onClick={handleLoginRedirect}
          >
            <Login />
          </button>
        </div>
      </Modal>

      {/* Contact button */}
      {editMode ? null : (
        <button
          className="musician-contact-form-button lg:absolute lg:bottom-[5px] lg:right-[60px] bg-white hover:bg-[#cdcdcd]/90 [&>svg]:text-black"
          onClick={showModal}
        >
          <Message />
        </button>
      )}
    </>
  )
}

export default MusicianContactForm
